import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiExhibitionCreatorsVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  currentUserPublicKey?: Types.InputMaybe<Types.Scalars['String']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiExhibitionCreators = { exhibitionCreatorStats: { totalItems: number, page: number, totalPages: number, items: Array<{ isFollowingUser: boolean, user: { username: string | null, name: string | null, profileImageUrl: string | null, publicKey: Address } }> } };



export const ApiExhibitionCreatorsDocument = /*#__PURE__*/ `
    query ExhibitionCreators($id: Int!, $currentUserPublicKey: String, $page: Int, $perPage: Int) {
  exhibitionCreatorStats(
    exhibitionId: $id
    accountAddress: $currentUserPublicKey
    page: $page
    perPage: $perPage
  ) {
    totalItems
    page
    totalPages
    items {
      user {
        publicKey: accountAddress
        username
        name
        profileImageUrl
      }
      isFollowingUser: isFollowing
    }
  }
}
    `;

export const useExhibitionCreators = <
      TData = ApiExhibitionCreators,
      TError = ClientError
    >(
      variables: ApiExhibitionCreatorsVariables,
      options?: Omit<UseQueryOptions<ApiExhibitionCreators, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiExhibitionCreators, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiExhibitionCreators, TError, TData>(
      {
    queryKey: ['ExhibitionCreators', variables],
    queryFn: apiFetcher<ApiExhibitionCreators, ApiExhibitionCreatorsVariables>(ApiExhibitionCreatorsDocument, variables),
    ...options
  }
    )};

useExhibitionCreators.getKey = (variables: ApiExhibitionCreatorsVariables) => ['ExhibitionCreators', variables];

export const useInfiniteExhibitionCreators = <
      TData = InfiniteData<ApiExhibitionCreators>,
      TError = ClientError
    >(
      variables: ApiExhibitionCreatorsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiExhibitionCreators, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiExhibitionCreators, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiExhibitionCreators, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ExhibitionCreators.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiExhibitionCreators, ApiExhibitionCreatorsVariables>(ApiExhibitionCreatorsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteExhibitionCreators.getKey = (variables: ApiExhibitionCreatorsVariables) => ['ExhibitionCreators.infinite', variables];


useExhibitionCreators.fetcher = (variables: ApiExhibitionCreatorsVariables, options?: RequestInit['headers']) => apiFetcher<ApiExhibitionCreators, ApiExhibitionCreatorsVariables>(ApiExhibitionCreatorsDocument, variables, options);
